import React from 'react';
import initState from './initState';

const AuthContext = React.createContext(initState);

export default AuthContext;
